import { Grid2Props } from '@mui/material';
import { GoMotoComponent } from '../../../API/GoMoto.types';
import { BaseGrid } from '../BaseGrid/BaseGrid';
import { forwardRef } from 'react';

/**
 * The MUI Grid2 wrapper control. This control exists for
 * any additional logic we might want to add on to the MUI Grid2 and as
 * a wrapper so that the `BaseGrid` control can be mocked.
 *
 * @props {@link Grid2Props}.
 */
const Grid: GoMotoComponent<Grid2Props> = forwardRef(({
    children,
    ...props
}, ref) => {
    return (
        <BaseGrid ref={ref} {...props}>
            {children}
        </BaseGrid>
    );
});

export default Grid;